import { ref, computed } from 'vue';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { useDisposes } from '@/composables/use-disposes';
import { DualViewSettingService } from '@/services/dual-view/service/dual-view-setting.service';
import { DualViewRefService } from '@/services/dual-view/service/dual-view-ref.service';
import type { DualViewSetting, SupportedSide, DualViewRefItem } from '@/services/dual-view/type/dual-view.type';

export function useDualViewStates() {
    const dualViewSettingService = injectService<DualViewSettingService>(DualViewSettingService);
    const dualViewRefService = injectService<DualViewRefService>(DualViewRefService);

    const { disposes } = useDisposes();

    const dualViewSetting = ref(dualViewSettingService.getModelData());
    const dualViewRef = ref(dualViewRefService.getModelData());

    disposes.push(
        dualViewSettingService.onStatesChange(states => dualViewSetting.value = states),
        // @ts-ignore
        dualViewRefService.onStatesChange(states => dualViewRef.value = states),
    );

    const leftRef = computed(() => dualViewRef.value.left);
    const rightRef = computed(() => dualViewRef.value.right);

    function updateDualViewSetting(options: DualViewSetting) {
        dualViewSettingService.updateSetting(options);
    }

    function updateDualViewRef(val: { side: SupportedSide, ref: DualViewRefItem }) {
        dualViewRefService.updateRefBySide(val);
    }

    function clearDualViewRef(side: SupportedSide) {
        dualViewRefService.clearRefBySide({ side });
    }

    return {
        leftRef,
        rightRef,
        dualViewSetting,
        updateDualViewSetting,
        updateDualViewRef,
        clearDualViewRef,
    };
}
